import Head from 'next/head'

export default function JsonLd({ data }) {
  if (!data) {
    return null
  }

  const items = Array.isArray(data) ? data.filter(Boolean) : [data].filter(Boolean)

  if (!items.length) {
    return null
  }

  return (
    <Head>
      {items.map((item, index) => (
        <script
          // eslint-disable-next-line react/no-danger
          key={item['@id'] || item['@type'] || index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </Head>
  )
}
